import { Component } from 'react';

class Embed extends Component {
  constructor(props) {
    super(props);

    this.storeEmbedStatus = this.storeEmbedStatus.bind(this);
  }

  storeEmbedStatus(status) {
    this.props.submission.setState({ status });
  }

  render() {
    const { item, renderEmbed, context } = this.props;

    return renderEmbed(
      item.content.id.toString(),
      {
        onStatusChange: this.storeEmbedStatus,
      },
      context,
    );
  }
}

function status(item, state = {}) {
  return state.status;
}

function version({ content }) {
  return content.id;
}

export default { Player: Embed, status, version };
